import React from 'react';
import './Header.css';
import koneLogo from '../kone-logo-blue.png';
import { cognitoConfig } from '../../LoginPage/config';

const Header = () => {

  const handleLogout = () => {
    sessionStorage.removeItem('access_token');
    sessionStorage.removeItem('idToken');
    sessionStorage.removeItem('isAuthenticated');

    // Redirect to landing page after clearing session
    window.location.href = '/';
  };

  return (
    <header className="header">
      <div className="logo">
        <img src={koneLogo} alt="KONE" className="logo-image" />
        <span className="app-name">TinyManager</span>
      </div>
      <button className="logout-button" onClick={handleLogout}>
        Logout
      </button>
    </header>
  );
};

export default Header;